import React, { Component } from "react";
import SimplifiedLayout from "./SimplifiedLayout";
import { Grid, Col, Row, Button } from "react-bootstrap";
import { LinkContainer } from "react-router-bootstrap";
import Helmet from 'react-helmet';

class NotFoundPage extends Component {
    render() {
        return (
            <div>
            	<Helmet title="Not Found"/>
                <SimplifiedLayout>
                    <Grid className="text-center">
                        <Row>
                            <Col sm={12}>
                                <h1>
                                    <i
                                        className="fa fa-question-circle-o fa-3x"
                                        aria-hidden="true"
                                    />
                                </h1>
                                <h2>Not found</h2>
                                <h4>
                                    The page you have requested does not exist
                                </h4>
                                <LinkContainer to="/">
                                    <Button bsStyle="primary">Main Page</Button>
                                </LinkContainer>

                            </Col>
                        </Row>

                    </Grid>
                </SimplifiedLayout>
            </div>
        );
    }
}

export default NotFoundPage;



// WEBPACK FOOTER //
// ./src/NotFoundPage.js